import React, { useEffect, useState } from 'react';
import { IMAGE_URL } from '../../utils/Constants';
import { resolveObjectStorageUrl } from '../../utils/objectStorage';
import { constructFileURL } from './Helper';
import moment from 'moment';
import Swal from 'sweetalert2';
import PermissionsGate from '../../utils/permissionGate';

const UploadSignatureFile = ({ disabled, fileInputRef, formik, setShowIp, readOnly = false, readOnlyData, setIsSig, isCancel, is_Signature, setIs_Signature, setIpAddress, setCDate, studentSubmissionDetails }) => {
  const [dragActive, setDragActive] = useState(false);
  const [image, setImage] = useState(null);
  const [readImage, setReadImage] = useState(null)

  useEffect(() => {
    if (isCancel) {
      setImage(null);
      setShowIp(null);
      setIs_Signature(false)
    }
  }, [isCancel])

  useEffect(() => {
    if (readOnly) {
      var readImage = constructFileURL(readOnlyData?.signature)

      setReadImage(readImage)
    }
  }, [readOnly, readOnlyData])

  useEffect(() => {
    if (is_Signature) {
      const rawSignature = readOnlyData?.signature;
  
      const imageURL = rawSignature?.startsWith("https://")
        ? rawSignature
        : (readOnlyData?.fileUploadedFrom == '1' || readOnlyData?.fileUploadedFrom == '2')
          // Phase 2 dual-read: 1 = S3, 2 = R2
          ? resolveObjectStorageUrl(rawSignature, readOnlyData?.fileUploadedFrom)
          : IMAGE_URL + "/" + rawSignature
              ?.replace("/home/myaie/public_html/", "")
              ?.replace("public/", "");
  
      setImage(imageURL || null);
    }
  }, [is_Signature]);  

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      // Handle file upload here
    }
    handleFiles(e.dataTransfer.files);
    formik.setFieldValue('lecturer_Signature', e.dataTransfer.files[0])
    setIsSig(e.dataTransfer.files[0])
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      // Handle file upload here\
    }
    handleFiles(e.target.files);
    formik.setFieldValue('lecturer_Signature', e.target.files[0])
    formik.setFieldValue('signature_type', 1);
    setIsSig(e.target.files[0])
    formik.setFieldValue('isDeleted', 0);

    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        setIpAddress(data.ip);
        formik.setFieldValue('signature_ip', data.ip);

        const currentDate = moment(new Date().getTime()).format('DD MMM YYYY, HH:mm');
        setCDate(currentDate);
        formik.setFieldValue('signature_date', currentDate);

        formik.handleSubmit();
      })
      .catch(error => {
        console.error('Error fetching IP address:', error);

        Swal.fire({
          title: "Error",
          text: "Failed to save signature. Please try again.",
          icon: "error"
        });
      });
  };

  const handleFiles = (files) => {
    setShowIp(true)
    const file = files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };


  return (
    <div className="max-w-md position-relative signature-pad-outer p-4 border border-gray-300 rounded-lg">
      {
        image || readOnly || is_Signature ? (
          <>
            <img src={readOnly ? readImage : image} style={{ color: '#467FCF', maxHeight: "175px" }} alt={`${readOnly ? readImage?.replace("https://aisuperadmin.devtechnosys.tech:17366/Library/Courses/", "") : image?.replace("https://aisuperadmin.devtechnosys.tech:17366/Library/Courses/", "")}`} className="max-w-full m-auto d-block object-contain" />
            <PermissionsGate scopes={studentSubmissionDetails?.isHybrid ? ["cassgradeassedit"] : ["overidersmart"]} errorProps={{ disabled: true }}>
              <div
              className={`${readOnly ? 'd-none' : ''} position-absolute ${disabled && "disabled-click"}`} style={{ cursor: readOnly ? "" : 'pointer', color: '#467FCF', top: '6px', right: '10px' }} onClick={() => {
                if (disabled) return;
                setImage(null)
                setShowIp(false)
                formik.setFieldValue('lecturer_Signature', "");
                formik.setFieldValue('signature_ip', "");
                formik.setFieldValue('signature_date', "");
                formik.setFieldValue('signature_type', 0);
                setIsSig(null)
                setIs_Signature(false)

                formik.setFieldValue('isDeleted', 1);
                formik.handleSubmit();
              }}
              title='Remove Uploaded Image'
              >
                Remove Uploaded Image<i className='fal ml-2 fa-trash-alt'></i>
              </div>
            </PermissionsGate>
          </>

        ) : (
          <label htmlFor="file-upload"
            className={`border-2 border-dashed rounded-lg p-6 text-center ${dragActive ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
              }`}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
          >
            {/* <Upload className="mx-auto h-12 w-12 text-gray-400" /> */}
            <i className='fal fa-upload' style={{ fontSize: '48px', color: '#467FCF' }}></i>
            <p className="mb-0 text-gray-600 mt-3">
              To upload your signature, Drop your file here, or{' '}
              <label
                htmlFor="file-upload"
                className="font-medium fw-bold text-blue-600 hover:underline cursor-pointer"
                style={{ color: "#467FCF", cursor: 'pointer' }}
              >
                click here to browse
              </label>
            </p>
            <p className="mt-1 text-xs" style={{ color: "#467FCF" }}>
              Supported Files: JPG and PNG
            </p>
            <PermissionsGate scopes={studentSubmissionDetails?.isHybrid ? ["cassgradeassedit"] : ["overidersmart"]} errorProps={{ disabled: true }}>
              <input
                id="file-upload"
                name="file-upload"
                type="file"
                className="d-none"
                ref={fileInputRef}
                onChange={handleChange}
                accept=".jpg,.png"
              />
            </PermissionsGate>

          </label>
        )
      }
    </div>
  );
};

export default UploadSignatureFile;